<template>
  <div class="monitor" style="font-size:16px;width:100%;background:#eff1f5">
    <div class="content">
      <div class="yuliang" ref="yuliang" style="margin-top:0;">
        <div class="select" ref="districtrainOperation">
          <span class="desc">起止时间:</span>
          <div style="display: inline-block;">
              <el-date-picker
              v-model="query.beginTime"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择开始时间"
              :picker-options="Global.pickerOptionsStart(query.endTime)"
              default-time="08:00:00">
            </el-date-picker>
            <span class="desc">至</span>
            <el-date-picker
              v-model="query.endTime"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择结束时间"
              :picker-options="Global.pickerOptionsEnd(query.beginTime)"
              default-time="08:00:00">
            </el-date-picker>
          </div>
          <span id="select" @click="tabledata">查询</span>
        </div>
        <div class="tableDiv" ref="tableDiv">
            <table>
              <thead ref="thead">
                <tr>
                <th>站点</th>
                <th v-html='yuLiangTh'></th>
                <th>站点</th>
                <th v-html='yuLiangTh'></th>
                <th>站点</th>
                <th v-html='yuLiangTh'></th>
                <th>站点</th>
                <th v-html='yuLiangTh'></th>
                <th class="gutter" style="width: 4px;"></th>
              </tr>
              </thead>
              <tbody ref="tbody" v-html="showTrData"></tbody>
            </table>
      </div>
    </div>
  </div>
 </div>
</template>
<script>
import monitorTypes from '@/store/types/monitor'
export default {
  data () {
    return {
      showTrData: '',
      query: {
        addvcd: '330324',
        beginTime: '',
        endTime: ''
      },
      yuLiangTh: '雨量</br>(mm)'
    }
  },
  methods: {
    tabledata () {
      this.$store.dispatch(monitorTypes.GET_ALLRAINFALL, {
        addvcd: this.query.addvcd,
        beginTime: this.query.beginTime,
        endTime: this.query.endTime
      }).then(data => {
        this.getShowDataTr(data.data)
      })
    },
    getShowDataTr (data) {
      this.showTrData = ''
      if (data !== {} && data !== undefined) {
        data.stationRain.forEach((element, index) => {
          if (index === 0) {
            this.showTrData = '<tr>'
          }
          if (index % 4 === 0 && index !== 0) {
            this.showTrData += '</tr><tr>'
          }
          this.showTrData += '<td>' + element.stnm + '</td>' + '<td>' + element.accRain + '</td>'
        })
        let stationRainLength = 4 - data.stationRain.length % 4
        for (let index = 0; index < stationRainLength; index++) {
          this.showTrData += '<td></td><td></td>'
        }
        if (this.showTrData !== '') {
          this.showTrData += '</tr>'
        }
        this.showTrData += '<tr><td colspan="8">最大:' + data.stnM_Max + data.accRain_Max + '毫米</td></tr>'
        this.showTrData += '<tr><td colspan="8">全县平均:' + data.accRain_Average + '毫米</td></tr>'
      }
    }
  },
  created () {
    let now = new Date()
    var preDate = new Date(now.getTime() - 24 * 60 * 60 * 1000) // 前一天
    this.query.beginTime = this.Global.timeFormat(preDate)
    this.query.endTime = this.Global.timeFormat(now)
    this.tabledata()
  },
  mounted () {
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      this.$refs['yuliang'].style.height = (contentDiv[0].offsetHeight - 30) + 'px'
      this.$refs['tableDiv'].style.height = (this.$refs['yuliang'].offsetHeight - 20 - this.$refs['districtrainOperation'].offsetHeight) + 'px'
      this.$refs['thead'].style.width = (this.$refs['tbody'].offsetWidth) + 'px'
      this.$refs['tbody'].style.height = (this.$refs['tableDiv'].offsetHeight - this.$refs['thead'].offsetHeight) + 'px'
    })
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped>
</style>
<style lang="less" scoped>
.monitor {
  .tableDiv{
    color:#000;
    margin-top: 5Px;
    width: 98%;
    margin-left: 1%;
     table {
      width: 100%;
      font-size: 15px;
      thead{
        display:table;
        width:100%;
        height: 50px;
        table-layout:fixed;
        // width: calc( 100% - 1em );
        // margin-right:0.15rem;
      }
      tr {
        height: 50px;
        display:table;
        width:100%;
        table-layout:fixed;
        background:rgb(245, 248, 251);
        th {
          text-align: center;
          vertical-align:middle;
          border:1px solid rgb(235, 239, 246);
        }
        th:nth-child(even) {
          width: 5%;
        }
        th:nth-child(odd) {
          width: 20%;
        }
      }
      tbody {
        overflow-y:scroll;
        display:block;
        height: 100px;
        /deep/ tr {
        display:table;
        width:100%;
        table-layout:fixed;
        text-align: center;
        vertical-align:middle;
        height: 50px;
        td {
          border:1px solid rgb(235, 239, 246);
        }
        td:nth-child(even) {
          width: 5%;
        }
        td:nth-child(odd) {
          width: 20%;
        }
        }
        /deep/ tr:nth-child(even) {
            background: rgb(232, 242, 251);
        }
        /deep/ tr:nth-child(odd) {
          background: rgb(255, 255, 255);
        }
      }
    }
  }
}
</style>
